import {
  Box,
  Button,
  ChevronRightIcon,
  CloseBigIcon,
  constants,
  Drawer,
  Text,
} from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import Image from 'next/legacy/image';
import React, { useState } from 'react';
import styles from './Coupon.module.scss';
import couponIcon from './coupon.svg';
import { couponMessages } from './messages';

type DrawerTriggerProps = {
  children: JSX.Element | JSX.Element[];
  setDrawerOrAccordionClosed: Function;
  drawerOrAccordionClosed: boolean;
  availableCoupons: number;
};

export const DrawerTrigger: React.FC<DrawerTriggerProps> = ({
  children,
  setDrawerOrAccordionClosed,
  drawerOrAccordionClosed,
  availableCoupons,
}) => {
  const intl = useIntl();
  const [open, setOpen] = useState(!drawerOrAccordionClosed);

  const onCloseHandler = () => {
    setOpen(false);
    setDrawerOrAccordionClosed(true);
  };
  return (
    <button
      type="button"
      onClick={() => {
        setOpen(true);
        setDrawerOrAccordionClosed(false);
      }}
      className={styles.trigger}
    >
      <Box display="flex">
        <Image alt="" layout="fixed" src={couponIcon} width={26} aria-hidden />
        <Box display="flex" flexDirection="column">
          <Text type="display5" marginLeft="xs" textAlign={constants.LEFT}>
            {intl.formatMessage(couponMessages.couponGiftCard)}
          </Text>
          {availableCoupons > 0 && (
            <Text
              type="caption"
              marginLeft="xs"
              className={styles.availableCoupons}
              textAlign={constants.LEFT}
            >
              {intl.formatMessage(couponMessages.couponAvailable, {
                count: availableCoupons,
              })}
            </Text>
          )}
        </Box>
      </Box>
      <ChevronRightIcon size={constants.MEDIUM} />

      <Drawer
        accessibleTitle={intl.formatMessage(couponMessages.couponGiftCard)}
        open={open}
        from={constants.BOTTOM}
        size={constants.LARGE}
        fit
        onCloseRequested={onCloseHandler}
        getApplicationNode={() => document.getElementById('__next')}
      >
        <Box display="flex" justifyContent="space-between">
          <Box marginTop="xs" marginLeft="m">
            <Text type="display3">
              {intl.formatMessage(couponMessages.couponGiftCard)}
            </Text>
          </Box>
          <Button
            strong
            circle
            inverse
            iconAfter={<CloseBigIcon size="medium" />}
            size={constants.LARGE}
            onClick={onCloseHandler}
          />
        </Box>

        <Box marginX="m" marginBottom="m">
          {children}
        </Box>
      </Drawer>
    </button>
  );
};
